import {
  Button,
  FormGroup,
  Link,
  Modal,
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  Table,
} from 'arag-ui-lib';

const StagedStep1 = (props) => {
  const {
    toggleCommissionModal,
    commissionModal,
    lawsysFirms,
    onSuggestionSelected,
    onSuggestionChange,
    addCommission,
    removeSolicitor,
    agentsList,
  } = props;

  const commissionAgents = agentsList.length > 0 ? agentsList : [];
  const columns = [
    {
      propertyName: 'agent',
      header: 'Agent',
      sortable: false,
      id: 'agent',
      formatter: (v) => {
        return (
          <div>
            <span>{v.name}</span>
            <div style={{ float: 'right' }}>
              <Link
                variant="tertiary"
                arrowDirection="left"
                label="Remove"
                onClick={() => removeSolicitor(v.id)}
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div>
      <div style={{ paddingBottom: 15 }}>
        <Button
          variant="tertiary"
          arrowDirection="right"
          label="Add new commission"
          onClick={toggleCommissionModal}
        />
      </div>
      <Table columns={columns} data={commissionAgents} />

      <Modal fadeIn={commissionModal} darkenedBackground>
        <ModalDialog size="lg">
          <ModalContent>
            <ModalHeader onClose={toggleCommissionModal} />
            <ModalBody>
              <FormGroup
                labelSize={'col-md-3'}
                inputSize={'col-xs-7'}
                label={`Agent`}
                variant={'searchableList'}
                inputProps={{
                  inputValue: lawsysFirms.suggestionFieldValue,
                  onInputChange: onSuggestionChange,
                  instanceId: 'agent',
                  value:
                    lawsysFirms.selectedLawsysFirmsDropdown.length > 0
                      ? lawsysFirms.selectedLawsysFirmsDropdown.map((l) => ({
                          value: l.id,
                          label: l.name,
                        }))[0]
                      : null,
                  onChange: (value) => onSuggestionSelected(value),
                  options: lawsysFirms.lawsysFirmsFiltered
                    .filter(
                      (x) => agentsList.some((s) => s.id === x.id) === false
                    )
                    .map((l) => ({ value: l.id, label: l.name })),
                  isLoading: lawsysFirms.fetching,
                  placeholder: 'Type at least 3 letters',
                  noOptionsText: `No Agents found`,
                  minSearchCharacters: 3,
                  isMulti: false,
                }}
              />

              <div style={{ paddingTop: 5, paddingBottom: 5 }}>
                <Button
                  variant="primary"
                  arrowDirection="right"
                  label="Add new commission"
                  disabled={
                    lawsysFirms.selectedLawsysFirmsDropdown.length === 0
                  }
                  onClick={addCommission}
                />
              </div>
              {/* <br/> */}
              <Link
                type="button"
                variant="tertiary"
                arrowDirection="left"
                label="Close"
                onClick={toggleCommissionModal}
              />
            </ModalBody>
          </ModalContent>
        </ModalDialog>
      </Modal>
    </div>
  );
};
export default StagedStep1;
